var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn-toggle',[_c('v-btn',[_c('v-icon',{attrs:{"large":""}},[_vm._v(" mdi-dice-d"+_vm._s(_vm.dice)+"-outline ")])],1),_c('v-btn',{on:{"click":_vm.newRoll}},[_vm._v(" "+_vm._s(_vm.currentNumber)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }